import { render, staticRenderFns } from "./AsociarVehiculos.vue?vue&type=template&id=1252ad40&"
import script from "./AsociarVehiculos.vue?vue&type=script&lang=ts&"
export * from "./AsociarVehiculos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports